export default __webpack_public_path__ + "static/media/107bed.de271af1.jpg";